import type { FC } from "react"

import { useSetRecoilState } from "recoil"
import styled from "styled-components"

import { ReactComponent as LocationPinMobile } from "~/assets/svg/powur-pin-icon.svg"

import { Icon } from "./Styles"
import { resetLocationModalIsOpenState } from "../../state/view"

const Wrapper = styled.div`
  transition: transform 0.2s ease-in-out;
  :hover {
    cursor: pointer;
    transform: scale(1.05);
  }
`
const StyledLocationPin = styled(Icon)`
  svg {
    width: 18px;
    height: 18px;
  }
`

export const ResetLocationButton: FC = () => {
  const setIsOpen = useSetRecoilState(resetLocationModalIsOpenState)

  return (
    <Wrapper title="Reset Location Pin" onClick={() => setIsOpen(true)}>
      <StyledLocationPin>
        <LocationPinMobile />
      </StyledLocationPin>
    </Wrapper>
  )
}
